import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-14",
  "use": "icon-sheet_icon-14-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-14\"><g transform=\"translate(-267 -267)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><circle cx=\"279\" cy=\"280\" r=\"9.25\" /><circle cx=\"279\" cy=\"271\" r=\"3.25\" /><circle cx=\"287\" cy=\"283\" r=\"3.25\" /><circle cx=\"271\" cy=\"283\" r=\"3.25\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol